import { render, staticRenderFns } from "./AboutItem.vue?vue&type=template&id=5de0c6de&scoped=true"
import script from "./AboutItem.vue?vue&type=script&lang=js"
export * from "./AboutItem.vue?vue&type=script&lang=js"
import style0 from "./AboutItem.vue?vue&type=style&index=0&id=5de0c6de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de0c6de",
  null
  
)

export default component.exports